import { end } from "@popperjs/core";

export function createDuration(time) {
  // create duration in seconds
  if (typeof time === "string") {
    let seconds = 0,
      exp = 2;
    for (let part of time.split(":", 3)) {
      seconds += parseInt(part, 10) * Math.pow(60, exp--);
    }
    time = { seconds: seconds };
  }

  return time;
}

export function cloneDate(date) {
  return new Date(date.getTime());
}

export function addDuration(date, duration, x = 1) {
  date.setUTCSeconds(date.getUTCSeconds() + x * duration.seconds);
  return date;
}

export function setMidnight(date) {
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

export function createDate(input) {
  if (typeof input === String && input.indexOf("T") !== -1) {
    return _fromISOString(input);
  } else if (typeof input === String && input.indexOf("T") === -1) {
    return _fromLocaltoUTC(input);
  } else if (typeof input === Object) {
    return _fromLocaltoUTC(new Date(input));
  }
  return _fromLocaltoUTC(new Date());
}

export function getDateWithStartTime(currentRange) {
  let start = cloneDate(currentRange.value.start);
  start.setUTCHours(8, 0, 0);
  return start.toISOString();
}

export function getDateWithEndTime(currentRange) {
  let end = cloneDate(currentRange.value.end);
  end.setUTCHours(21, 0, 0);
  return end.toISOString();
}

export function createUTCDate(date) {
  const d = new Date(date);
  return new Date(
    Date.UTC(
      d.getFullYear(),
      d.getMonth(),
      d.getDate(),
      d.getHours(),
      d.getMinutes(),
      d.getSeconds()
    )
  );
}

export function getDates(startDate, endDate) {
  const dates = [];
  let currentDate = startDate;
  const addDays = function (days) {
    const date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
  };

  while (currentDate <= endDate) {
    dates.push(currentDate);
    currentDate = addDays.call(currentDate, 1);
  }
  return dates;
}

/**
 * Private functions
 */

function _fromISOString(str) {
  const parts = str.match(/\d+/g);
  return new Date(
    Date.UTC(
      Number(parts[0]),
      Number(parts[1]) - 1,
      Number(parts[2]),
      Number(parts[3]),
      Number(parts[4]),
      Number(parts[5])
    )
  );
}

function _fromLocaltoUTC(input) {
  let d = new Date(input);
  return new Date(
    Date.UTC(
      d.getUTCFullYear(),
      d.getUTCMonth(),
      d.getUTCDate(),
      d.getUTCHours(),
      d.getUTCMinutes(),
      d.getUTCSeconds()
    )
  );
}
